export default __webpack_public_path__ + "static/media/icon_logout.6ed400e6.svg";